// extracted by mini-css-extract-plugin
export default {"errorDialog":"Layout_errorDialog__rQp60","dialogBody":"Layout_dialogBody__QNZUR"};